$(function () {
    (function certTabs() {
        var certTabNavItems = $(".cert-tabs__nav-item");
        var certPanels = $(".cert-tabs__panel");

        certTabNavItems.on("click", function (e) {
            e.preventDefault();
            var targetPanel = $("[data-panel-id='" + $(this).data("target-panel") + "']");
            certTabNavItems.removeClass("active");
            certPanels.removeClass("active");
            $(this).addClass("active");
            targetPanel.addClass("active");
        });
    }());

    $(window).on("load", function() {
        var hash = window.location.hash;
        var validPanelIds = $(".cert-tabs__panel").map(function () {
            return $(this).data("panel-id");
        }).get();

        if (hash && validPanelIds.includes(hash.substring(1))) {
            var panelId = hash.substring(1);
            var targetPanel = $("[data-panel-id='" + panelId + "']");
            
            if (targetPanel.length) {
                $(".cert-tabs__nav-item[data-target-panel='" + panelId + "']").trigger("click");
                
                setTimeout(function() {
                    var isMobile = $(window).width() < 768; // Common mobile breakpoint
                    
                    if (isMobile) {
                        smoothScrollToElement(targetPanel[0]);
                    } else {
                        var navElement = $(".cert-tabs__nav");
                        if (navElement.length) {
                            smoothScrollToElement(navElement[0]);
                        }
                    }
                }, 150);
            }
        }
    });
})